import dynamic from "next/dynamic";
import Head from "next/head";
import { useRouter } from "next/router";

import { useEffect } from "react";

import { collectionUrl } from "components/CollectionPageLayout";
import { useApi } from "hooks/useApi";

const CollectionPageInsightsList = dynamic(
  () =>
    import(
      "components/CollectionPageLayout/CollectionPageAnalysis/CollectionPageInsightsList"
    )
);

type CollectionPageAnalysisProps = {};

const CollectionPageAnalysis = ({}: CollectionPageAnalysisProps) => {
  const router = useRouter();
  const slug = router.query.slug as string;
  const currentTab = router.query.tab;

  const { data: collection } = useApi(collectionUrl(slug));
  const { name, description: collectionDescription } = collection || {};

  const tabContent = <CollectionPageInsightsList />;

  useEffect(() => {
    if (!collection?.hadInsightsPublished && !collection?.hadReportsPublished)
      return;

    if (currentTab === "reports" && !collection?.hadReportsPublished) {
      router.replace(`/collections/${slug}/research`);
    }
    if (
      (!currentTab || currentTab === "insights") &&
      !collection?.hadInsightsPublished
    ) {
      router.replace(`/collections/${slug}/research?tab=reports`);
    }
  }, [
    currentTab,
    collection?.hadInsightsPublished,
    collection?.hadReportsPublished,
    router,
    slug,
  ]);

  const title = `${name} - Research`;
  const description = `${collectionDescription}. Explore this collection on Smartkarma`;

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
      </Head>
      {tabContent}
    </>
  );
};

export default CollectionPageAnalysis;
